<template>
  <div >

    <a-modal
        :title='title'
        :visible="visible"
        v-bind="drawerConfig"
        :body-style="{ paddingBottom: '80px' }"
        @cancel="onClose"
    >

    <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout"   layout="vertical">
      <a-form-model-item
          ref="translate_keyword_prompt"
          label="翻译关键词句式"
          prop="translate_keyword_prompt"
          :help="formErr.translate_keyword_prompt"
          :validateStatus='!formErr.translate_keyword_prompt||formErr.translate_keyword_prompt==""?"":"error"'
      >
        <a-input type="textarea"
            :maxLength=1000
            v-model="form.translate_keyword_prompt"
            @change="(e) => { formErr.translate_keyword_prompt=''}"
            @blur="(e) => {  form.translate_keyword_prompt = e.target.value.trim();}"
        />
      </a-form-model-item>
      <a-form-model-item
          ref="related_words_prompt"
          label="生成相关词句式"
          prop="related_words_prompt"
          :help="formErr.related_words_prompt"
          :validateStatus='!formErr.related_words_prompt||formErr.related_words_prompt==""?"":"error"'
      >
        <a-input type="textarea"
                 :maxLength=1000
                 v-model="form.related_words_prompt"
                 @change="(e) => { formErr.related_words_prompt=''}"
                 @blur="(e) => {  form.related_words_prompt = e.target.value.trim();}"
        />
      </a-form-model-item>
      <a-form-model-item
          ref="translate_content_prompt"
          label="有图翻译文章句式"
          prop="translate_content_prompt"
          :help="formErr.translate_content_prompt"
          :validateStatus='!formErr.translate_content_prompt||formErr.translate_content_prompt==""?"":"error"'
      >
        <a-input type="textarea"
                 :maxLength=1000
                 v-model="form.translate_content_prompt"
                 @change="(e) => { formErr.translate_content_prompt=''}"
                 @blur="(e) => {  form.translate_content_prompt = e.target.value.trim();}"
        />
      </a-form-model-item>
      <a-form-model-item
          ref="translate_content_no_image_prompt"
          label="无图翻译文章句式"
          prop="translate_content_no_image_prompt"
          :help="formErr.translate_content_no_image_prompt"
          :validateStatus='!formErr.translate_content_no_image_prompt||formErr.translate_content_no_image_prompt==""?"":"error"'
      >
        <a-input type="textarea"
                 :maxLength=1000
                 v-model="form.translate_content_no_image_prompt"
                 @change="(e) => { formErr.translate_content_no_image_prompt=''}"
                 @blur="(e) => {  form.translate_content_no_image_prompt = e.target.value.trim();}"
        />
      </a-form-model-item>

    </a-form-model>
    <div class="drawer-btn"  style="text-align: center" >

      <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
        确定
      </a-button>
      <a-button @click="onClose">
        取消
      </a-button>
    </div>
  </a-modal></div>
</template>

<script>
import {submitForm,drawerConfig,validator} from "../../../../../../utils/utils"

import API from "../api";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  name: "videoForm",
  // props: ["visible","title","editId"],
  props: {
    visible:{type: Boolean,},
    title:{type: String,},
    editId:{type: [String, Number],},

  },
  data() {
    return {
      contenta: "",
      headers: {Authorization: window.sessionStorage.getItem("signature")},
      seleList:[],
      fileList:[],
      previewVisible: false,
      previewImage: "",
      drawerConfig ,
      form: {
        translate_keyword_prompt:"",
        related_words_prompt:"",
        translate_content_prompt:"",
        translate_content_no_image_prompt:'',
        type:"5",
      },
      formErr: {
        translate_keyword_prompt:"",
        related_words_prompt:"",
        translate_content_prompt:"",
      },
      rules: {
        translate_keyword_prompt: [{required: true, message: "请输入翻译关键词句式",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.translate_keyword_prompt)}  , trigger: "blur"  },],
        related_words_prompt: [{required: true, message: "请输入生成相关词句式",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.related_words_prompt)}  , trigger: "blur"  },],
        translate_content_prompt: [{required: true, message: "请输入有图翻译文章句式",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.translate_content_prompt)}  , trigger: "blur"  },],
        translate_content_no_image_prompt: [{required: true, message: "请输入无图翻译文章句式",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.translate_content_no_image_prompt)}  , trigger: "blur"  },],

      },
      layout: {
        // labelCol: { span:3},
        // wrapperCol: { span: 20 },

      },
    };

  },
  watch:{
    editId: function (a, b) {
      if (a != "") {
        API.service.EDIT_DATA(a).then(res => {
          let data=res.data.data.info
          this.form = data
          this.form.id=a
          this.form.type='5'
        })
      } else {
        this.form.id = ''
      }
    }
  },
  mounted(){
  },
  methods: {

    handleCancel() {
      this.previewVisible = false;
    },

    onClose() {
      this.$emit("changVisible", false);
      this.fileList=[]
      this.formErr={
        translate_keyword_prompt:"",
        related_words_prompt:"",
        translate_content_prompt:"",
        translate_content_no_image_prompt:''
      }
      this.$refs.ruleForm.resetFields();
    },
    onSubmit() {
      let _this = this;

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url
          let subData=JSON.parse(JSON.stringify(this.form))

          subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
          submitForm(url, subData).then(res => {
            if (res == true) {
              this.onClose()
            } else {
              res.map((item, index) => {
                this.formErr[item.field] = item.msg
              })
            }
          })
        } else {
          return false;
        }
      });
    },
  },
}
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
.box >>> .ant-form-extra{top:calc(100% - 30px) !important;position: absolute}
.box >>> .ant-form-item-control-wrapper{position: relative}
.drawer-btnt{text-align:center;}
</style>
